<template>
    <div :class="['attendance-status-card primary', { loading }, { active }]" @click="$emit('click')" v-if="custom">
        <div class="status-symbol">{{ customStatusName[0] }}</div>
        <div>{{ customStatusName }}</div>
    </div>
    <div
        :class="[
            'attendance-status-card',
            { loading },
            { active },
            { danger: active && includesOneOfStatuses('absent', 'leave') },
            { success: active && !includesOneOfStatuses('absent', 'leave') },
        ]"
        @click="handleStatusUpdate"
        v-else-if="attendanceStatus"
    >
        <div class="status-symbol">{{ attendanceStatus.name[0] }}</div>
        <div>{{ attendanceStatus.name }}</div>
    </div>
</template>

<script>
import { mapActions } from "vuex"

export default {
    emits: ["updated"],
    props: {
        attendanceStatus: {
            type: Object,
            default: () => null,
        },
        attendanceRecord: {
            type: Object,
            default: () => null,
        },
        active: {
            type: Boolean,
            default: () => false,
        },
        custom: {
            type: Boolean,
            default: () => false,
        },
        customStatusName: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        ...mapActions("misc", ["updateAttendanceRecord"]),
        includesOneOfStatuses(...statuses) {
            return statuses.some((item) => this.attendanceStatus.name.toLowerCase().includes(item))
        },
        async handleStatusUpdate() {
            if (this.loading || !this.attendanceRecord || !this.attendanceStatus) return
            this.loading = true
            try {
                await this.updateAttendanceRecord({
                    id: this.attendanceRecord.id,
                    attendanceStatusId: this.attendanceStatus.id,
                })
            } catch (err) {
                console.log("error in updating status", err)
            }
            this.$emit("updated")
            this.loading = false
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.attendance-status-card {
    border: 1px solid $gray200;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    border-radius: $radiusSm;
    gap: 10px;
    font-size: 13px;
    font-weight: 500;
    color: $gray600;
    background: white;
    cursor: pointer;
    transition: all $transitionFast;

    &.loading {
        opacity: 0.6;
        pointer-events: none;
    }
    &.active .status-symbol {
        background: white;
        color: $gray800;
    }
    &.active {
        color: white;
        font-weight: 600;
    }
    &.success {
        background: $success;
        border-color: $success;
    }
    &.danger {
        background: $danger;
        border-color: $danger;
    }
    &.primary {
        background: $info;
        border-color: $info;
    }

    &:hover:not(.active) {
        background: $gray50;
        border-color: $gray300;
    }
}
.status-symbol {
    background: $gray100;
    color: $gray600;
    text-align: center;
    padding: 3px;
    font-weight: 700;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    border-radius: 6px;
    flex-shrink: 0;
}

@media (max-width: 480px) {
    .attendance-status-card {
        padding: 8px 10px;
        font-size: 12px;
    }
    .status-symbol {
        width: 28px;
        height: 28px;
        font-size: 11px;
    }
}
</style>
